import { z } from "zod";

const formSchema = z.object({
  rate: z.union([z.number(), z.string()]),
  number_of_month: z.union([z.number(), z.string()]),
  monthly_ticket_count: z.union([z.number(), z.string()]),
  total_ticket_count: z.union([z.number(), z.string()]),
  total_amount: z.union([z.number(), z.string()]),
  start_date: z.preprocess((arg) => {
    if (typeof arg === "string" || arg instanceof Date) {
      return new Date(arg);
    }
    return arg;
  }, z.date().optional().nullable()),
  end_date: z.preprocess((arg) => {
    if (typeof arg === "string" || arg instanceof Date) {
      return new Date(arg);
    }
    return arg;
  }, z.date().optional().nullable()),
  service_type_id: z.union([z.number(), z.string()]),
  internal_ticket_type_id: z.union([z.number(), z.string()]),
  internal_sub_ticket_type_id: z.union([z.number(), z.string()]),
  periods: z.array(
    z.object({
      rate: z.string().optional().nullable(),
      ticketsCount: z.string().optional().nullable(),
      maand: z.string().optional().nullable(),
    })
  ).optional().nullable(),
});

export default formSchema;